import { AssociationId } from "../../types"
import { DocValidityStatusEnum } from "../../enums"
import { getDocNameMetaData } from "../../utils"

class PFDoc {
  private generatedUnixMs
  private docFamily
  private docName
  private association
  private ownerPk
  private fileName
  private fieldData
  private docValidityStartDate
  private docValidityExpiryDate

  constructor(association: AssociationId, ownerPk: string, fileName: string, fieldData: Record<string, any>) {
    const docNameMetaData = getDocNameMetaData(fileName)
    if (!docNameMetaData) {
      throw new Error("Invalid doc name format")
    }
    const { generatedUnixMs, docFamily, docName } = docNameMetaData
    this.generatedUnixMs = generatedUnixMs
    this.docFamily = docFamily
    this.docName = docName
    this.association = association
    this.ownerPk = ownerPk
    this.fileName = fileName
    this.fieldData = fieldData
    this.docValidityStartDate = fieldData.docValidityStartDate || null
    this.docValidityExpiryDate = fieldData.docValidityExpiryDate || null
  }

  getDocName = () => {
    return this.docName
  }

  getDocFamily = () => {
    return this.docFamily
  }

  getDocGeneratedUnixMs = () => {
    return this.generatedUnixMs
  }

  getValidPeriod = () => {
    if (!this.docValidityStartDate && !this.docValidityExpiryDate) {
      return DocValidityStatusEnum.NO_PERIOD_SET
    }
    const start = this.docValidityStartDate || "NONE"
    const end = this.docValidityExpiryDate || "NONE"
    return `${start} - ${end}`
  }

  getValidityStatus = () => {
    const currentDate = new Date().getTime()
    if (!this.docValidityExpiryDate) {
      return DocValidityStatusEnum.NO_EXPIRY_SET
    }
    if (currentDate > new Date(this.docValidityExpiryDate).getTime()) {
      return DocValidityStatusEnum.EXPIRED
    } else if (currentDate > new Date(this.docValidityExpiryDate).getTime() - 3888000000) {
      return DocValidityStatusEnum.EXPIRES_IN_45_DAYS
    }
    return DocValidityStatusEnum.VALID
  }

  getAllDocMetaData = () => {
    const docName = this.getDocName()
    const docFamily = this.getDocFamily()
    const generatedUnixMs = this.getDocGeneratedUnixMs()
    const validPeriod = this.getValidPeriod()
    const validityStatus = this.getValidityStatus()
    return {
      docName,
      docFamily,
      generatedUnixMs,
      fileName: this.fileName,
      association: this.association,
      ownerPk: this.ownerPk,
      validPeriod,
      validityStatus,
    }
  }
}
export default PFDoc
